//
// Sets up Swiper for the slider in the website
// @see https://swiperjs.com/get-started
//

import SwiperCore, {
  A11y,
  EffectFade,
  Navigation,
  Pagination,
} from 'swiper/core';

SwiperCore.use([A11y, EffectFade, Navigation, Pagination]);

const slider = new SwiperCore('.c-gallery', {
  a11y: {
    enabled: true,
  },
  centeredSlides: true,
  loop: true,
  loopedSlides: 3,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  slidesPerView: 'auto',
  spaceBetween: 4,
});

export default slider;
